import { library, dom, config } from '@fortawesome/fontawesome-svg-core';

import {
  faAngleUp, faCircleNotch,
  faSignIn, faSignOut, faUser,
  faCheck, faExclamationTriangle,
  faDownload, faDeleteLeft,
  // Control Panel button
  faCogs, faCopy, faKey
} from '@fortawesome/free-solid-svg-icons';

config.autoAddCss = false;
config.keepOriginalSource = false;
config.autoReplaceSvg = true;
config.observeMutations = true;

library.add(
  faAngleUp,
  faCircleNotch,
  faSignIn,
  faSignOut,
  faUser,
  faCheck,
  faExclamationTriangle,
  faDownload,
  faDeleteLeft,
  faCogs,
  faCopy,
  faKey
);
dom.watch();
